import React, { useState, useEffect } from "react";
import "./EditPostModal.css"; // âœ… You can style if needed

const COMMUNITY_OPTIONS = [
  { value: "General", label: "General" },
  { value: "AI", label: "AI" },
  { value: "Crypto", label: "Crypto" },
  { value: "Economy", label: "Economy" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Finance", label: "Finance" },
  { value: "Health", label: "Health" },
  { value: "Media", label: "Media" },
  { value: "News", label: "News" },
  { value: "Politics", label: "Politics" },
  { value: "Science", label: "Science" },
  { value: "Sports", label: "Sports" },
  { value: "Technology", label: "Technology" },
  { value: "Travel", label: "Travel" },
  { value: "Weather", label: "Weather" },
  { value: "World", label: "World" },
];

const EditPostModal = ({ post, onClose, onSave }) => {
  const [editedContent, setEditedContent] = useState(post?.content || "");
  const [editedCategory, setEditedCategory] = useState(
    post?.communityCategory || post?.category || "General"
  );
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (post) {
      setEditedContent(post.content || "");
      setEditedCategory(post.communityCategory || post.category || "General");
    }
  }, [post]);

  const handleSave = async () => {
    if (!editedContent.trim()) {
      alert("Post content cannot be empty!");
      return;
    }

    setSaving(true);

    try {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (!currentUser) {
        alert("You must be logged in to edit posts.");
        setSaving(false);
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/posts/${post.id}/edit`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            content: editedContent,
            category: editedCategory,
            userId: currentUser.id,
          }),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Failed to save post edit.");
      }

      console.log("âœ… Post updated:", result.post || result.updatedPost);

      if (typeof onSave === "function") {
        onSave(result.post || result.updatedPost);
      }

      onClose();
    } catch (err) {
      console.error("âŒ Error saving edited post:", err);
      alert("Failed to save changes. See console for details.");
    } finally {
      setSaving(false);
    }
  };

  if (!post) return null;

  return (
    <div className="edit-post-overlay">
      <div className="edit-post-modal">
        <h2>Edit Post</h2>

        <textarea
          value={editedContent}
          onChange={(e) => setEditedContent(e.target.value)}
          rows={4}
          style={{ width: "100%", resize: "none" }}
        />

        <div style={{ marginTop: "12px" }}>
          <label
            htmlFor="editPostCommunity"
            style={{ display: "block", marginBottom: "6px", fontWeight: "600" }}
          >
            Community
          </label>
          <select
            id="editPostCommunity"
            value={editedCategory}
            onChange={(e) => setEditedCategory(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              boxSizing: "border-box",
            }}
          >
            {COMMUNITY_OPTIONS.map((community) => (
              <option key={community.value} value={community.value}>
                {community.label}
              </option>
            ))}
          </select>
        </div>

        <div className="edit-post-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPostModal;
